var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_956_4877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "#FFD93B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 36.0001C72 55.8901 55.8788 72.0001 36 72.0001C24.6825 72.0001 14.58 66.7801 7.97626 58.6013C14.1525 63.5963 22.0163 66.5776 30.5775 66.5776C50.4563 66.5776 66.5775 50.4676 66.5775 30.5776C66.5775 22.0163 63.5963 14.1526 58.6013 7.97632C66.7688 14.5801 72 24.6826 72 36.0001Z",
    fill: "#F4C534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7483 54.1125C46.7483 55.1633 45.909 55.9868 44.874 55.9868H27.1283C26.0933 55.9868 25.254 55.161 25.254 54.1125C25.254 53.0775 26.0933 52.2383 27.1283 52.2383H44.874C45.9068 52.2383 46.7483 53.0775 46.7483 54.1125Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.723 36.7988C16.6028 36.2813 19.206 39.0713 23.2943 39.2243C27.5265 39.3818 29.9858 36.2813 30.8655 36.7988C31.9613 37.1745 30.4673 44.3295 23.2943 44.3565C16.1235 44.3295 14.6273 37.1745 15.723 36.7988Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0355 33.6531C13.2187 33.5226 12.6607 32.7531 12.7935 31.9341C12.9262 31.1174 13.6822 30.5571 14.5125 30.6921C22.9455 32.0466 25.5082 26.0234 25.533 25.9626C25.8435 25.1954 26.7165 24.8264 27.4882 25.1391C28.2555 25.4519 28.6245 26.3271 28.3117 27.0944C26.6197 31.2389 21.3052 34.8209 14.0355 33.6531Z",
    fill: "#E9B02C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.277 36.7988C55.3973 36.2813 52.794 39.0713 48.7058 39.2243C44.4735 39.3818 42.0143 36.2813 41.1345 36.7988C40.0388 37.1745 41.5328 44.3295 48.7058 44.3565C55.8765 44.3295 57.3728 37.1745 56.277 36.7988Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6883 27.0923C43.3755 26.3251 43.7445 25.4498 44.5118 25.1371C45.2768 24.8243 46.1498 25.1911 46.4648 25.9538C46.5773 26.2238 49.1535 32.0311 57.4875 30.6923C58.3133 30.5573 59.076 31.1176 59.2065 31.9343C59.337 32.7533 58.7813 33.5228 57.9645 33.6533C50.7465 34.8143 45.3938 31.2751 43.6883 27.0923Z",
    fill: "#E9B02C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_956_4877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.d5d78d8f3313219ea5327bcf24b91215.svg";
export { ForwardRef as ReactComponent };